<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        Update Agent
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Update Agent</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="agents"
                item-text="email"
                item-value="id"
                @change="selectAgent"
                :loading="loadingAgents"
                :disabled="loadingAgents"
                label="Choose Agent"
              />
            </v-col>
            <v-col cols="12" v-if="agent_selected">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  v-model="agent.fname"
                  :rules="requiredRules"
                  label="First Name"
                  required
                />
                <v-text-field
                  v-model="agent.lname"
                  :rules="requiredRules"
                  label="Last Name"
                />
                <v-text-field
                  v-model="agent.email"
                  label="Email"
                  :rules="emailRules"
                  required
                />
                <v-text-field
                  v-model="agent.twilio_phone"
                  label="Twilio Phone"
                  required
                  counter="13"
                  v-mask="'(###)###-####'"
                />
                <v-autocomplete
                  v-model="agent.subroles"
                  :items="subroles"
                  item-text="title"
                  item-value="id"
                  persistent-hint
                  label="Choose sub-roles"
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="changeAllSubrolesHandler">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            agent.subroles.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index == 0">
                      <span>{{ item.title }}</span>
                    </v-chip>
                    <span v-if="index == 1" class="grey--text caption">
                      (+{{ agent.subroles.length - 1 }} others sub-roles)
                    </span>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  v-model="agent.states"
                  :items="baseData.states"
                  item-text="name"
                  item-value="code"
                  persistent-hint
                  label="Choose states"
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="changeAllStatesHandler">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            agent.states.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index == 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index == 1" class="grey--text caption">
                      (+{{ agent.states.length - 1 }} others states)
                    </span>
                  </template>
                </v-autocomplete>
                <v-checkbox v-model="agent.banned" label="Banned" />
                <v-checkbox v-model="agent.not_assign" label="Not Asssign" />
                <v-text-field
                  v-model="password"
                  label="Password"
                  @input="generatePassword = ''"
                  type="password"
                  required
                />
                <v-text-field
                  v-if="password"
                  v-model="password_confirm"
                  label="Re-Enter Password"
                  type="password"
                  :rules="pwdConfirmRules"
                  required
                />
                <div class="justify-center">
                  <h3 class="mb-3">
                    Generated password: {{ generatePassword }}
                  </h3>
                  <v-btn class="success" small @click="generateRandomPassword">
                    Generate Password
                  </v-btn>
                </div>
                <div class="justify-center mt-3">
                  <h3 class="mb-3">Email credentials:</h3>
                </div>
                <v-text-field
                    v-model="clientId"
                    label="Client ID"
                />
                <v-text-field
                  v-model="clientSecret"
                  label="Client secret"
                />
                <v-text-field
                    v-model="refreshToken"
                    label="Refresh token"
                />
                <v-text-field
                    v-model="accessToken"
                    label="Access token"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn
          color="blue darken-1"
          :disabled="!valid"
          text
          @click="updateAgent"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UpdateAgentForm",
  props: {
    user_id: Number,
  },
  data() {
    return {
      open: false,
      password: "",
      password_confirm: "",
      generatePassword: "",
      clientId: "",
      clientSecret: "",
      refreshToken: "",
      accessToken: "",
      agent: {},
      agent_selected: false,
      lazy: false,
      valid: false,
      allStates: false,
      allRoles: false,
      requiredRules: [(value) => !!value || "Required."],
      emailRules: [
        (value) => !!value || "Required.",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Invalid Email address",
      ],
      pwdConfirmRules: [
        (value) => !!value || "Required.",
        (value) => value === this.password || "Password must be the same",
      ],
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      loadAgents: "agents/loadAgents",
      loadSubroles: "agents/loadSubroles",
    }),

    changeAllStatesHandler() {
      this.allStates = !this.allStates;

      if (this.allStates) {
        this.agent.states = this.baseData.states.map((state) => state.code);
      } else this.agent.states = [];
    },

    changeAllSubrolesHandler() {
      this.allRoles = !this.allRoles;

      if (this.allRoles) {
        this.agent.subroles = this.subroles.map((roles) => roles.id);
      } else this.agent.subroles = [];
    },

    generateRandomPassword() {
      this.generatePassword = Math.random().toString(36).substr(2, 12);
      this.password = this.generatePassword;
      this.password_confirm = this.generatePassword;
    },

    selectAgent(e) {
      this.agent = this.agents.find((agent) => agent.id == e);
      if (
        this.agent.email_credentials !== null &&
        this.agent.email_credentials.accessToken !== ""
      ) {
        this.clientId = this.agent.email_credentials.clientId;
        this.clientSecret = this.agent.email_credentials.clientSecret;
        this.refreshToken = this.agent.email_credentials.refreshToken;
        this.accessToken = this.agent.email_credentials.accessToken;
      }
      this.agent_selected = true;
      console.log('agent', this.agent);
    },

    updateAgent() {
      const agent = {
        fname: this.agent.fname,
        lname: this.agent.lname,
        email: this.agent.email,
        email_credentials: {
          clientId: this.clientId,
          clientSecret: this.clientSecret,
          refreshToken: this.refreshToken,
          accessToken: this.accessToken,
        },
        twilio_phone: this.agent.twilio_phone,
        states: this.agent.states,
        banned: this.agent.banned,
        not_assign: this.agent.not_assign,
        subroles: this.agent.subroles,
      };

      if (this.password !== "") {
        agent.password = this.password;
      }

      this.$axios
        .put(`/agents/${this.agent.id}`, agent)
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) => {
          console.log(err.response);
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
  },
  mounted() {
    this.loadAgents();
    this.loadSubroles();
  },
  computed: {
    ...mapGetters({
      agents: "agents/agents",
      loadingAgents: "agents/loadingAgents",
      baseData: "baseData/baseData",
      subroles: "agents/subroles",
    }),
    selectedAllStates() {
      return this.agent.states.length === this.baseData.states.length;
    },
    selectedSubroles() {
      return this.agent.subroles.length === this.subroles.length;
    },
    selectedSomeStates() {
      return this.agent.states.length > 0 && !this.agent.states;
    },
    icon() {
      if (this.selectedAllStates) return "mdi-close-box";
      if (this.selectedSubroles) return "mdi-close-box";
      if (this.selectedSomeStates) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
};
</script>